// extracted by mini-css-extract-plugin
export default {"articlesList":"about-page_articlesList__g44DX","element":"about-page_element__EURvo","frameList":"about-page_frameList__dZ35j","frame":"about-page_frame__ZT7V0"};